<template>
    <!--Waiting List Enrollment Step One-->
    <div class="enroll-info-screen">
        <div class="enroll-wrapper">
            <h6 class="sub-title">{{ $t("waitingListEnroll.subTitle") }}</h6>
            <div class="steps">
                <p class="highlight-text">{{ $t("waitingListEnroll.step1") }}</p>
                <i class="fa fa-check-circle-o" aria-hidden="true"></i>
            </div>
            <div class="steps">
                <p class="highlight-text">{{ $t("waitingListEnroll.step2") }}</p>
                <i
                    v-if="currentSection === 'congratulation-section'"
                    class="fa fa-check-circle-o"
                    aria-hidden="true"
                ></i>
            </div>
            <div class="enroll-wrapper start-subscription-content" v-if="currentSection !== 'congratulation-section'">
                <p>
                    For the first month, you’ll receive the Waitlist service for free. This trial period allows you to
                    explore all the features and see if they’re a good fit for your business. After the first month,
                    your subscription will renew annually at {{ profileCurrency }}{{ enrollmentCostYearly }} , billed to
                    the card ending in {{ defaultCard.last4 }}.
                </p>
                <div class="waiting-list-signature section-wrap">
                    <p>Please sign below to confirm you agree with the terms.</p>
                    <div class="signature-container">
                        <VueSignaturePad
                            class="signature"
                            ref="signaturePad"
                            :sigOption="signatureOption"
                            :w="screenWidth"
                            :h="'200px'"
                            @endStroke="checkIfSigned"
                        >
                        </VueSignaturePad>
                    </div>
                    <div class="signature-btns-container">
                        <button class="secondary-btn small mobile" @click="clearSignature">Clear</button>
                    </div>
                    <div class="checkbox-inputs-container">
                        <div class="input-checkbox">
                            <div class="input-box">
                                <input
                                    v-model="isAgree"
                                    @click="checkIfSigned"
                                    type="checkbox"
                                    id="agreement"
                                    name="Agreement"
                                    :value="isAgree"
                                />
                            </div>
                            <label
                                for="agreement"
                                class="checkbox-label-wrap"
                                v-html="$t('waitingListEnroll.agree')"
                            >
                            </label>
                        </div>
                    </div>
                </div>
                <div class="next-step">
                    <button
                        @click="createWaitingListBraintreeSubscription()"
                        :disabled="!isSigned || !isAgree"
                        :class="!isSigned || !isAgree ? 'disabled-button' : ''"
                        class="primary-btn extra-small mobile"
                    >
                        Continue
                    </button>
                    <button @click="changeScreen('enroll-step-one')" class="secondary-btn small mobile">Go back</button>
                </div>
            </div>
            <div class="after-start-subscription-content" v-if="currentSection === 'congratulation-section'">
                <!--Enrollment Congratulation-->
                <enroll-congratulation
                    text="Thank you for signing up! <br> Your free trial has been successfully activated. <br> <br> Please continue to the next step."
                    nextScreen="enroll-step-three"
                    buttonText="Continue"
                    @change-screen="changeScreen"
                ></enroll-congratulation>
            </div>
        </div>
    </div>
</template>

<script>
import api from "../../../../services/apiEndpoints";
import store from "../../../../services/vuex";
import EnrollCongratulation from "./EnrollCongratulation.vue";
import $ from "jquery";
import eventBus from "../../../../services/eventBus";

import VueSignaturePad from "vue3-signature-pad"; 

export default {
    data() {
        return {
            profile: {},
            signatureOption: {
                penColor: "rgb(0, 0, 0)",
                backgroundColor: "rgb(255,255,255)",
            },
            screenWidth: "",
            isAgree: false,
            isSigned: false,
            currentSection: "",
            profileCurrency: "$",
            subscriptionUsersNum: 1,
            enrollmentCostYearly: 12,
        };
    },
    computed: {
        adminDetails: {
            get: function () {
                return this.$store.state.adminDetails;
            },
            set: function (value) {
                this.$store.commit("setAdminDetails", value);
            },
        },
        defaultCard: {
            get: function () {
                return this.$store.state.defaultCard;
            },
            set: function (value) {
                this.$store.commit("setDefaultCard", value);
            },
        },
    },
    mounted() {
        this.enrollmentCostYearly = import.meta.env["VITE_ENROLLMENT_COST_YEARLY"];

        this.getStylistProfile();
        this.getScreenWidth();

        $(document).on("click", ".signature-container canvas", () => {
            this.checkIfSigned();
        });
    },
    components: { VueSignaturePad, EnrollCongratulation },
    methods: {
        changeScreen(screen) {
            this.$emit("change-screen", screen);
        },

        getStylistProfile() {
            this.profile = this.adminDetails.profile;
        },

        clearSignature() {
            var _this = this;
            _this.$refs.signaturePad.clear();
            this.isSigned = false;
        },

        getScreenWidth() {
            if (window.innerWidth < 375) {
                this.screenWidth = "258px";
            }
            if (window.innerWidth >= 375) {
                this.screenWidth = "300px";
            }

            if (window.innerWidth > 620) {
                this.screenWidth = "536px";
            }

            if (window.innerWidth > 991) {
                this.screenWidth = "700px";
            }
        },

        checkIfSigned() {
            const signaturePad = this.$refs.signaturePad;

            // Check if the signature pad is empty
            if (signaturePad && !signaturePad.isEmpty()) {
                this.isSigned = true; // Enable the next button if signature is drawn
            } else {
                this.isSigned = false; // Disable the next button if signature is empty
            }
        },

        changeSection(section) {
            this.currentSection = section;
        },

        createWaitingListBraintreeSubscription() {
            if (this.loading) {
                return;
            }

            this.loading = true;

            let data = {
                users_number: 1,
                app_id: this.generalOptions.app_id,
                signature: this.$refs.signaturePad.save(),
                dataImage: 1,
            };

            this.$http.post(api.actions.save_waiting_list_braintree_subscription, data).then((response) => {
                if (response.data.error == true) {
                    return;
                }
                this.loading = false;

                eventBus.emit("reload_user_details");
                this.changeSection("congratulation-section");
            });
            return;
        },
    },
};
</script>
